import { transformImgSrc } from "src/components/Image";
import { Drink } from "../db";

export default function useGetDrinkIconUrl(drink: Drink) {
  if (drink.ownDrink) {
    return transformImgSrc(drink.icon);
  }

  return `/alcohol-image/${drink.icon}`;
}
